import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import MainHeader from 'components/templateParts/MainHeader';
import dataProvider, { GET_ONE, UPDATE } from "providers/dataProvider";
import withForm from 'withForm';
import { clientsResource } from "config/resources/clientsResource";
import { compose } from 'redux'
import { withNotificationCenter } from 'NotificationCenter'
import BaseForm from 'components/ui_components/BaseForm/BaseForm';
import BaseFormControls from 'components/ui_components/BaseFormControls/BaseFormControls';
import style from './ClientEditContainer.module.scss';

const styles = () => ({
  main: {
    margin: '32px 26px 0',
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2)',
    borderRadius: '4px',
    backgroundColor: 'white',
    padding: '30px 15px 30px'
  }
});

const { inputsById, inputsGroupsByHash } = clientsResource.editConfig;
const inputsByHash = clientsResource.createConfig.inputsByHash;
const inputsGroupsById = clientsResource.createConfig.inputsGroupsById;

const withFormConfig = {inputsByHash, inputsById };

const ClientEditContainer = (props) => {
  const { classes, inputsById, inputsByHash, handleInputs, id } = props;

  // On edit load, explicitly fetch the client and push country/state
  // into the form so that relativeInputs (country -> state) are
  // triggered and the states API is called.
  useEffect(() => {
    if (!id) return;

    dataProvider(GET_ONE, 'clients', { id }).then(({ data }) => {
      if (!data) return;

      // Set country first to trigger relativeInputs for state
      if (data.clientCountryId) {
        handleInputs({
          target: { name: 'clientCountryId', value: data.clientCountryId },
        });
      }

      // Then set state id so the autocomplete can preselect it
      if (data.clientStateId) {
        handleInputs({
          target: { name: 'clientStateId', value: data.clientStateId },
        });
      }
    });
  }, [id, handleInputs]);

  const handleSubmit = () => {
    const { notificationCenter, history, isFormValid, resetErrors, getSubmitData } = props;

    if (isFormValid()) {
      resetErrors();
      const submitData = getSubmitData()

      dataProvider(UPDATE, 'clients', { data: submitData, id: props.id })
      .then((response) => {
        notificationCenter.show('Successfully updated', 'info')
        history.push('/clients/' + response.data.id + '/show');
      })
      .catch(error => {
        notificationCenter.show(error.message, 'warning')
      });
    }
  }

  return (
    <div>
      <MainHeader title="Edit Client"/>
      <div className={classes.main}>
        <div className={style.form}>
          <BaseForm
            inputsById={inputsById}
            inputsByHash={inputsByHash}
            handleInputs={handleInputs}
            inputsGroupsById={inputsGroupsById}
            inputsGroupsByHash={inputsGroupsByHash}
          />
        </div>

        <BaseFormControls
          type={'edit'}
          handleClickSubmit={handleSubmit}
          submitLabel='Update Client'
          deleteConfirmationMessagePostfix={'client'}
          resource='clients'
          id={props.id}
        />
      </div>
    </div>
  );
}

const ClientEditWithForm = compose(
  withNotificationCenter(),
  withForm({ ...withFormConfig, mode: 'edit' }),
  withStyles(styles)
)(ClientEditContainer);

// Wrapper component to extract route params and inject history from React Router v6
const ClientEditContainerWrapper = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const history = { push: navigate };
  return <ClientEditWithForm {...props} id={id} history={history} />;
};

export default ClientEditContainerWrapper;